import { render, staticRenderFns } from "./GeneratorChooser.vue?vue&type=template&id=50bb7a47"
import script from "./GeneratorChooser.vue?vue&type=script&lang=ts"
export * from "./GeneratorChooser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports